import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65badbf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "run-button" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "dot dot1"
}
const _hoisted_4 = {
  key: 1,
  class: "dot dot2"
}
const _hoisted_5 = {
  key: 2,
  class: "dot dot3"
}
const _hoisted_6 = {
  key: 0,
  class: "queries-left text-yellow-500 text-sm"
}
const _hoisted_7 = {
  key: 1,
  class: "queries-left text-yellow-900 text-sm mt-1"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:andreykypaku@gmail.com",
  class: "underline"
}, "administrator", -1))
const _hoisted_9 = {
  key: 2,
  class: "queries-left text-yellow-900 text-sm mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeyWarning = _resolveComponent("KeyWarning")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LogIn = _resolveComponent("LogIn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_KeyWarning, { value: _ctx.showKeyDescription }, null, 8, ["value"]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('run'))),
      disabled: _ctx.disabled || (!_ctx.left && _ctx.$root.mode !== 'client'),
      class: _normalizeClass(["mt-2 px-8 py-1 rounded", _ctx.disabled || !_ctx.left ? 'bg-green-200' : 'bg-green-300'])
    }, [
      _createElementVNode("b", null, _toDisplayString(_ctx.isLoading ? 'Loading' : 'Run'), 1),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "."))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "."))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "."))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    (_ctx.$root.mode !== 'client')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.left <= 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "You have " + _toDisplayString(_ctx.left) + " requests left", 1))
            : _createCommentVNode("", true),
          (_ctx.left <= 0 && _ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createTextVNode(" To acquire additional requests, it is necessary to either reach out to the "),
                _hoisted_8,
                _createTextVNode(" or establish an "),
                _createVNode(_component_router_link, {
                  to: "/settings",
                  class: "font-bold underline ml-1 sm:ml-0"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("API Key")
                  ]),
                  _: 1
                }),
                _createTextVNode(". ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.left <= 0 && _ctx.guest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(" To acquire additional requests, it is necessary to sign up or establish an "),
                _createVNode(_component_router_link, {
                  to: "/settings",
                  class: "font-bold underline ml-1 sm:ml-0"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("API Key")
                  ]),
                  _: 1
                }),
                _createTextVNode(". ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.left <= 0 && _ctx.guest)
            ? (_openBlock(), _createBlock(_component_LogIn, { key: 3 }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}